import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaWindowShapeOptions } from '../upp-konva-options';

/** Window shape. */
export class UppKonvaWindowShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'WINDOW' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaWindowShapeOptions) {
        const { shape, ...rest } = opts;
        super({ ...rest, data: { shape } });
    }
}
